import { useContext, useState } from "react";
import { AmlVerificationContext } from "@/context/aml_verification";
import HeaderButton from "@/components/ui/HeaderButton";
import { faThumbtack } from "@fortawesome/pro-duotone-svg-icons";
import IdentityService from "@/services/identity";
import PinAmlSidebar from "@/components/aml/PinAmlSidebar";
import * as Notification from "@/components/ui/Notification";

export default function AmlVerificationHeader() {
  const [amlVerification] = useContext(AmlVerificationContext);
  const [pinOpen, setPinOpen] = useState(false);

  async function UnpinTask() {
    await IdentityService.UnpinTask(amlVerification.task.session_id)
      .then(async () => {
        window.location.reload();
      })
      .catch((err) => {
        Notification.error(err.message);
      });
    return () => {};
  }

  return (
    <>
      <div className="flex flex-wrap justify-between pb-3">
        <div className="flex">
          <div className="ml-3 sm:ml-0">
            <img
              className="h-8 rounded-lg"
              src={amlVerification.app.logo_url}
            ></img>
          </div>
          <div className="ml-3">
            {amlVerification.task.pin === false ? (
              <HeaderButton
                onClick={() => setPinOpen(true)}
                currentBg="primary-500"
                icon={faThumbtack}
                type="pin"
                label="Pin"
              ></HeaderButton>
            ) : (
              <HeaderButton
                currentBg="primary-500"
                onClick={() => UnpinTask()}
                icon={faThumbtack}
                type="pin"
                label="Unpin"
              ></HeaderButton>
            )}
          </div>
          <div className="ml-2">
            <p className="text-white text-2xs uppercase font-bold">
              {amlVerification.app.name}
            </p>
            <h1 className="text-2xs text-white">
              {amlVerification.task.session_id}
            </h1>
          </div>
        </div>
        <PinAmlSidebar open={pinOpen} setOpen={setPinOpen}></PinAmlSidebar>
      </div>
    </>
  );
}
